document.addEventListener('DOMContentLoaded', () => {
  initYotpoPointsWidget();
});

// Add Shopify section events handlers
document.addEventListener('shopify:section:load', () => {
  initYotpoPointsWidget();
});

document.addEventListener('shopify:section:select', () => {
  initYotpoPointsWidget();
});

// Move initYotpoPointsWidget outside the DOMContentLoaded handler
const initYotpoPointsWidget = () => {
  const yotpoPointsWidgets = document.querySelectorAll('.yotpo-pdp-points-widget');
  if (!yotpoPointsWidgets?.length) return;

  // Create observer for each widget
  yotpoPointsWidgets.forEach((widget) => {
    try {
      const observer = new MutationObserver((mutations) => {
        try {
          const targetNode = mutations[0]?.target;
          if (!targetNode) return;

          const pointsAmount = targetNode.querySelector('.yotpo-product-points-widget-points-amount');
          if (!pointsAmount?.textContent) return;

          const numericPoints = parseInt(pointsAmount.textContent, 10);
          if (isNaN(numericPoints)) return;

          const productPriceElement = document.querySelector('[data-product-price]');
          let formattedPoints; 
          
          if (productPriceElement) {
            const priceText = productPriceElement.textContent.trim();
            const cleanPriceText = priceText.replace(/[^\d.,]/g, '').replace(',', '');
            const productPrice = parseFloat(cleanPriceText);
            
            if (!isNaN(productPrice)) {
              const cashbackPercentage = window.theme?.settings?.loyaltyCashbackPercentage || 10;
              const cashbackDecimal = cashbackPercentage / 100;
              
              const cashbackAmount = productPrice * cashbackDecimal;
              formattedPoints = Math.floor(cashbackAmount * 100) / 100;
              formattedPoints = formattedPoints.toFixed(2);
              
            } else {
              const cashbackPercentage = window.theme?.settings?.loyaltyCashbackPercentage || 10;
              const cashbackDecimal = cashbackPercentage / 100;
              
              formattedPoints = (numericPoints * cashbackDecimal).toFixed(2);
            }
          } else {
            const cashbackPercentage = window.theme?.settings?.loyaltyCashbackPercentage || 10;
            const cashbackDecimal = cashbackPercentage / 100;
            
            formattedPoints = (numericPoints * cashbackDecimal).toFixed(2);
          }

          const widgetContainer = targetNode.parentElement?.parentElement?.parentElement;
          if (!widgetContainer) return;

          const pointsTextContainer = widgetContainer.querySelector('.yotpo-pdp-points-widget-text');
          const pointsElement = pointsTextContainer?.querySelector('.yotpo-pdp-points-widget-text-points');

          if (!pointsTextContainer || !pointsElement) return;

          pointsElement.textContent = `$${formattedPoints}`;
          pointsTextContainer.style.display = 'flex';
          pointsTextContainer.style.opacity = '0';
          pointsTextContainer.style.transition = 'opacity 0.15s ease-in';
          setTimeout(() => {
            pointsTextContainer.style.opacity = '1';
          }, 0);

          // Initialize Tippy tooltip on the icon if tooltip text exists
          const tooltipIcon = widgetContainer.querySelector('.yotpo-pdp-points-widget-text-points-suffix-icon');
          if (tooltipIcon) {
            const tooltipText = tooltipIcon.getAttribute('data-tooltip-text');
            if (tooltipText) {
              tippy(tooltipIcon, {
                content: tooltipText,
                placement: 'top',
              });
            }
          }

          observer.disconnect(); // Stop observing once found
        } catch (error) {
          console.error('Error processing Yotpo points widget mutation:', error);
        }
      });

      // Set observation options
      const observerOptions = {
        childList: true,
        subtree: true,
      };

      // Start observing
      observer.observe(widget, observerOptions);
    } catch (error) {
      console.error('Error setting up Yotpo points widget observer:', error);
    }
  });
};

function getYotpoPoints(maxWaitTime = 10000, intervalTime = 500) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const intervalId = setInterval(() => {
      // Check if we've exceeded the maximum wait time
      if (Date.now() - startTime > maxWaitTime) {
        clearInterval(intervalId);
        reject(new Error('Timeout waiting for Yotpo widget'));
        return;
      }

      // Look for the points element within the logged-in view
      const pointsElement = document.querySelector('.yotpo-logged-in-view .yotpo-description-points-balance .yotpo-inner-text');

      if (pointsElement) {
        clearInterval(intervalId);
        const points = parseInt(pointsElement.textContent);
        
        const cashbackPercentage = window.theme?.settings?.loyaltyCashbackPercentage || 10;
        const cashbackDecimal = cashbackPercentage / 100;
        
        const formattedPoints = (points * cashbackDecimal).toFixed(2);
        resolve(`$${formattedPoints}`);
      }
    }, intervalTime);
  });
}

getYotpoPoints()
  .then((points) => {
    document.querySelector('[data-yotpo-points]').textContent = points;
  })
  .catch((error) => {
    console.error('DEBUG: Failed to get Yotpo points:', error);
  });
